<template>
  <div class="index_home">

    <IndxHead></IndxHead>
    <div class="w100" style="height: 800px;">
      <section class="fourNm">
        <h1 style="color: #24509e; font-size: 50px; ">开拓新价值·共创新未来</h1>
        <p style="color: #4d71b1;font-size: 20px;">跨行业资源整合</p>
      </section>

    </div>
    <div>
      <!--  -->

      <section id="education" class="eduBox">
        <div>
          <h1 class="pt-100 color-2" style="font-size: 30px;">文都教育</h1>
          <p class="line-block" style="margin:auto"></p>
          <p class="text-uppercase " style="font-size: 16px; color: #cccccc;margin-top: 10px;">Wendu Education</p>
        </div>
        <div>
          <div class="pt-50 color-2" style="line-height: 2;">
            文都教育是道信资本投资的第一个教育类项目，文都教育教学网 <br>
            点覆盖全国95%以上的本科院校。考研业务市场占有率位居第一。经营业绩保持高速增长，<br>
            一度成为投资者的热捧，pre-IPO融资达2.5亿美元，<br>
            荣膺2019年度教育单笔融资榜首。
          </div>
          <img :src="img1" alt="" class="img1">
        </div>
      </section>


      <!--  -->
      <section id="agriculture" class="hgBox">
        <div>
          <h1 class="pt-100 color-2" style="font-size: 30px;padding-top: 190px;">黄冈现代农业综合体</h1>
          <p class="line-block" style="margin:auto"></p>
          <p class="text-uppercase " style="font-size: 16px; color: #cccccc;margin-top: 10px;">Huanggang Modern
            Agricultural Complex</p>
        </div>
        <div>
          <div class="pt-50 color-fff" style="line-height: 2;padding-top:160px;">
            该项目是探索解决”三农“问题的示范项目，通过引入<br>
            生态循环科技手段，实现区域农业实现产业化、现代化，科学化和生产绿色无害化，<br>全西提升果蔬，蛋、奶、肉等农产品的档次<br>
            和质量，带动地方经济振兴、大幅提高衣民收入。<br>
            该项目占地2750亩，总投资22亿，平均静态投饰收益率超过53%。
          </div>

        </div>
      </section>
      <!--  -->


      <section id="ai"  class="aiBox">
        <div>
          <h1 class="pt-100 color-2" style="font-size: 30px;">Emokit Ai项目服务 </h1>
          <p class="line-block" style="margin:auto"></p>
          <p class="text-uppercase " style="font-size: 16px; color: #cccccc;margin-top: 10px;">EmoKit Ail project
            services</p>
        </div>
        <div>
          <div class="pt-50 color-2" style="line-height: 2;">
            EmoKitA是一家专注于情感智能识别技术的创新企业，我们 <br>
            为其提供了融资策划与市场拓展策路。助力其快速成长。通过精准定位目标市场与潜<br>在投资者，我们或功帮助EmoKit Ai吸引了大量关注<br>与投资，加速了其技术商业化进程。
          </div>
          <img :src="img2" alt="" class="img2">
        </div>
      </section>
      <!--  -->

      <section  id="healthcare" class="gyBox">
        <div>
          <h1 class="pt-100 color-2" style="font-size: 30px;">爱泰普医药项目服务 </h1>
          <p class="line-block" style="margin:auto"></p>
          <p class="text-uppercase " style="font-size: 16px; color: #cccccc;margin-top: 10px;">Aitep Pharmaceutical
            Project Services</p>
        </div>
        <div>
          <div class="pt-50 color-2" style="line-height: 2;">
            爱泰普医药致力于多肱新药研发与生物技术创新。我们 <br>
            为其提供了全面的财务麟问与资本运作服务。从新药研发的伤金筹集到市场推广策腔的制定，<br>我们全方位支持爱泰普医药的创新发展，助力其在医药领城取得突破性进展。
          </div>
          <!-- <img :src="img2" alt="" class="img1"> -->
        </div>
      </section>

      <!--  -->

      <section>

        <IndxFoot></IndxFoot>
      </section>
    </div>
  </div>
</template>

<script>
import img1 from '../images/ip111.png'
import img2 from '../images/ip22.png'
import IndxHead from '@/components/IndxHead.vue'
import IndxFoot from '@/components/IndxFoot.vue'

export default {
  name: 'HomePage',
  components: {
    IndxHead,
    IndxFoot,

  },
  data() {
    return {
      img1: img1,
      img2: img2

    }
  },
  mounted() {
    this.scrollToSection();
  },
  beforeUnmount() {

  },
  methods: {
    scrollToSection() {
      // 在下一个tick执行，确保DOM已经渲染完成
      this.$nextTick(() => {
        const section = this.$route.query.section;
        if (section) {
          // 延迟执行，确保页面完全加载
          setTimeout(() => {
            const element = document.getElementById(section);
            if (element) {
              // 计算导航栏高度，确保滚动位置正确
              const headerHeight = 80; // 根据您的导航栏高度调整
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }
          }, 300);
        }
      });
    },
    //
  },
  watch: {
    // 监听路由参数变化，当参数变化时重新滚动
    '$route.query.section': {
      handler(newVal) {
        if (newVal) {
          this.scrollToSection();
        }
      },
      immediate: false
    }
  }
}
</script>

<style scoped>
#education, #agriculture {
  scroll-margin-top: 80px; /* 根据导航栏高度调整 */
}

.img1 {
  width: 700px;
  mix-blend-mode: multiply;
  margin-top: 20px;
}


.img2 {
  width: 700px;
  mix-blend-mode: multiply;
  margin-top: 20px;
  position: relative;
  left: 220px;
}

.eduBox {
  background: url(/src/images/cm11.png) no-repeat;
  background-size: cover;
  height: 1000px;
  width: 100%;
}

.hgBox {
  background: url(/src/images/ip3.png) no-repeat;
  background-size: cover;
  height: 800px;
  width: 100%;
}

.aiBox {
  background: url(/src/images/ip32.png) no-repeat;
  background-size: cover;
  height: 860px;
  width: 100%;
}

.gyBox {
  background: url(/src/images/cp4.png) no-repeat;
  background-size: cover;
  height: 880px;
  width: 100%;
}

.fourNm {
  width: 100%;
  height: 100%;
  background: url(../images/ip1.png) no-repeat;
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  flex-direction: column;
}
</style>